import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_HR.json';
import exercises from './FITNESS_EXERCISES_HR.json';
import recipes from './FITNESS_RECIPES_HR.json';

export const FITNESS_DATA_HR: ServiceData = {
  articles,
  exercises,
  recipes,
};
